import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { Search, Download, ChevronUp, ChevronDown } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export interface UserFiltersData {
  nameLike?: string;
  email?: string;
  pageSize?: number;
}

interface UserFiltersProps {
  onFilterChange: (filters: UserFiltersData) => void;
  includeInactive: boolean;
  onIncludeInactiveChange: (value: boolean) => void;
}

export function UserFilters({
  onFilterChange,
  includeInactive,
  onIncludeInactiveChange,
}: UserFiltersProps) {
  const [showFilters, setShowFilters] = useState(true);
  const [nameLike, setNameLike] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [pageSize, setPageSize] = useState<string>("10");

  const handleFilter = () => {
    onFilterChange({
      nameLike: nameLike || undefined,
      email: email || undefined,
      pageSize: parseInt(pageSize),
    });
  };

  const handleClearFilters = () => {
    setNameLike("");
    setEmail("");
    setPageSize("10");
    onIncludeInactiveChange(false);
    onFilterChange({});
  };

  return (
    <div className="space-y-2">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setShowFilters(!showFilters)}
        className="filter-toggle"
      >
        {showFilters ? <ChevronUp className="h-3 w-3" /> : <ChevronDown className="h-3 w-3" />}
        {showFilters ? "Esconder Filtros" : "Mostrar Filtros"}
      </Button>

      {showFilters && (
        <div className="filter-box">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-2 items-end">
            <div className="space-y-1">
              <Label htmlFor="nameLike" className="filter-label">Nome (parcial)</Label>
              <Input
                id="nameLike"
                placeholder="Digite parte do nome"
                className="filter-input"
                value={nameLike}
                onChange={(e) => setNameLike(e.target.value)}
              />
            </div>

            <div className="space-y-1">
              <Label htmlFor="email" className="filter-label">Email</Label>
              <Input
                id="email"
                type="email"
                placeholder="Digite o email"
                className="filter-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="space-y-1">
              <Label htmlFor="pageSize" className="filter-label">Registros por Página</Label>
              <Select value={pageSize} onValueChange={setPageSize}>
                <SelectTrigger id="pageSize" className="filter-input">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent className="bg-popover z-50">
                  <SelectItem value="10">10</SelectItem>
                  <SelectItem value="20">20</SelectItem>
                  <SelectItem value="50">50</SelectItem>
                  <SelectItem value="100">100</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="flex gap-2 items-center">
              <div className="flex items-center gap-2 flex-1">
                <Checkbox
                  id="includeInactive"
                  checked={includeInactive}
                  onCheckedChange={onIncludeInactiveChange}
                />
                <Label htmlFor="includeInactive" className="filter-label cursor-pointer">
                  Incluir inativos
                </Label>
              </div>
              <Button size="default" onClick={handleFilter} className="btn-header">
                <Search className="btn-header-icon" /> Filtrar
              </Button>
              <Button size="default" variant="outline" onClick={handleClearFilters} className="btn-header">
                Limpar
              </Button>
              <Button size="default" variant="outline" className="btn-header">
                <Download className="btn-header-icon" />
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
